import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  chartWrapper: {
    height: '400px'
  }
})

export default useStyles
